module.exports = __webpack_public_path__ + "media/images/mobile/city_img/d-d5f302bb900c2051613f1f203523e079.jpg";